/**
 * Endpoint for creating an account
 *
 * Copyright (C) 2020A Noom, Inc.
 * @author nikola
 */

import axios from "axios";

import { Api } from "@noom/noomscape";

import { User } from "@/models";
import { captureException } from "@/utils/sentry";

// This is passed as an environment variable at build time,
// or when running locally from the .env file at the root of the project
const ANONYMOUS_CLIENT_TOKEN = process.env.HIVE_ANONYMOUS_CLIENT_TOKEN;

export type ResponseData = {
  accessCode: string;
  wasCreated: boolean;
  businessType: string;
  pricingType: string;
};

Api.register(
  "account.create",
  async ({ upid, userData }: { upid: string; userData: User }) => {
    if (!ANONYMOUS_CLIENT_TOKEN) {
      const error = new Error("ANONYMOUS_CLIENT_TOKEN is not set");
      if (process.env.NODE_ENV === "development") {
        // eslint-disable-next-line no-console
        console.error(error);
      } else {
        captureException(error);
      }
      return Promise.reject(error);
    }

    const response = await axios({
      url: "/users/create",
      urlWithPathParams: "/users/create",
      baseURL: window.ENV.SERVER_URL,
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${ANONYMOUS_CLIENT_TOKEN}`,
      },
      data: { ...userData, upid },
    });

    return response.data;
  },
);
